import { render, staticRenderFns } from "./AllocationChartLegend.vue?vue&type=template&id=a9b92c3c&scoped=true&"
import script from "./AllocationChartLegend.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AllocationChartLegend.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AllocationChartLegend.vue?vue&type=style&index=0&id=a9b92c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b92c3c",
  null
  
)

export default component.exports